import { render, staticRenderFns } from "./list3Edit.vue?vue&type=template&id=6a4af9e4&"
import script from "./list3Edit.vue?vue&type=script&lang=js&"
export * from "./list3Edit.vue?vue&type=script&lang=js&"
import style0 from "./list3Edit.vue?vue&type=style&index=0&id=6a4af9e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports